import { CustomerRepository } from './repositories/customer'
import { CustomerService } from './services/customer'

const customerRepository = new CustomerRepository()

export const customerService = new CustomerService({
    customerRepository,
})
